import React, { useState, useEffect } from 'react';
import CategoryForm from '../Categories/CategoryForm';
import CategoryList from '../Categories/CategoryList';
import MenuItemForm from './MenuItemForm';
import MenuItemList from './MenuItemList';

const MenuPage = ({
  categories,
  menuItems,
  onAddCategory,
  onDeleteCategory,
  onEdit,
  onAddMenuItem,
  onDeleteMenuItem,
  onUpdateMenuItem,
  supplies = []  // FIX: necesario para el form de variantes
}) => {
  const [editingItem, setEditingItem]   = useState(null);
  // FIX: grupos de variantes cargados una vez en MenuPage
  const [variantGroups, setVariantGroups] = useState([]);

  // FIX: cargar grupos al montar
  useEffect(() => {
    fetch('/api/variants/get_variant_groups.php')
      .then(res => res.json())
      .then(data => { if (data.success) setVariantGroups(data.groups || []); })
      .catch(err => console.error('Error cargando variantes:', err));
  }, []);

  const handleEditItem = (item) => setEditingItem(item);
  const handleCancelEdit = () => setEditingItem(null);

  const handleSaveItem = (itemData) => {
    onUpdateMenuItem(itemData);
    setEditingItem(null);
  };

  return (
    <div className="space-y-6 mt-6">

      {/* Categorías */}
      <div>
        <CategoryForm onSubmit={onAddCategory} />
        <div className="mt-6">
          <CategoryList
            categories={categories}
            onDelete={onDeleteCategory}
            onEdit={onEdit}
          />
        </div>
      </div>

      {/* Productos */}
      <div>
        <MenuItemForm
          categories={categories}
          onSubmit={onAddMenuItem}
          editingItem={editingItem}
          onSaveItem={handleSaveItem}
          onCancelEdit={handleCancelEdit}
          // FIX: pasar grupos y supplies para la sección de variantes
          variantGroups={variantGroups}
          supplies={supplies}
          onVariantGroupsChange={setVariantGroups}
        />
        <div className="mt-6">
          <MenuItemList
            items={menuItems}
            onDelete={onDeleteMenuItem}
            onEditItem={handleEditItem}
          />
        </div>
      </div>

    </div>
  );
};

export default MenuPage;